"use client";

import type { User } from "@packages/domain";
import { useQuery } from "@tanstack/react-query";
import { queryFn, queryKey } from "@/app";
import { USER_DATA_QUERY, type UserDataDTO } from "@/queries";

export type UseUserDataResourceParams = {
  user: User | null;
  enabled: boolean;
};

export function useUserDataResource({
  user,
  enabled,
}: UseUserDataResourceParams) {
  return useQuery<UserDataDTO | null>({
    queryKey: queryKey(USER_DATA_QUERY, [user]),
    queryFn: queryFn(USER_DATA_QUERY, [user]),
    enabled: enabled && !!user,
  });
}
